import { Box } from "@chakra-ui/layout";
import { Modal } from "antd";
import FormVincularUnidade from "./FormVincularUnidade";

interface ModalVincularUnidadeProps {
  idGrupo: string;
  visible: boolean;
  onClose: () => any;
  onSuccess?: () => any;
}

function ModalVincularUnidade({
  idGrupo,
  visible,
  onClose,
  onSuccess,
}: ModalVincularUnidadeProps) {
  return (
    <Modal
      centered
      visible={visible}
      footer={null}
      onCancel={onClose}
      width="700px"
      destroyOnClose
    >
      <Box>
        <FormVincularUnidade
          visible={visible}
          onClose={onClose}
          idGrupo={idGrupo}
          onSuccess={onSuccess}
        />
      </Box>
    </Modal>
  );
}

export default ModalVincularUnidade;
